<template>
	<div class="statuses-container" v-if="isActive">
		<div class="statuses-floater mouse-pointer" @click="onClick">
			<WarningFilled class="qa-overlay-icon"/> {{ overlayLabel }}
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';
import { WarningFilled } from '@ant-design/icons-vue';

import { datetimeToStringFormat } from '@/components/common/dateUtils';
import { useLicenseStore } from '@/stores/licenseStore';
import { useI18n } from 'vue-i18n';

export default {
	components: {
		WarningFilled,
	},
	setup() {
		const { t } = useI18n();
		const licenseStore = useLicenseStore();
		const isActive = computed(() => (
			licenseStore.qaOverlay != null && licenseStore.qaOverlay.active
		));
		const overlayLabel = computed(() => {
			const overlay = licenseStore.qaOverlay;
			if (overlay == null) {
				return '';
			}
			return t('license.qaOverlay', {
				vrs: overlay.allowVrs ? '+' : '-',
				ppp: overlay.allowPppRtk ? '+' : '-',
				gp: overlay.allowPppGp ? '+' : '-',
				expires: datetimeToStringFormat(overlay.expiresAt, 'YYYY-MM-DD HH:mm:ss'),
			});
		});
		const onClick = () => {
			licenseStore.refresh();
		};

		return {
			isActive,
			overlayLabel,
			onClick,
		};
	},
}
</script>
<style scoped>
@import '@/assets/floaters.css';

.qa-overlay-icon {
	color: #722ed1;
	margin-inline-end: 4px;
}
</style>
